import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Quote, ArrowRight } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import api from "../lib/api";

const PLACEHOLDERS = [
  { name: "Your Name Here", event_type: "Wedding", quote: "Share your experience with Taste of Platinum. Real client testimonials will appear here.", rating: 5 },
  { name: "Your Name Here", event_type: "Corporate Event", quote: "This space is ready for authentic reviews from our valued clients.", rating: 5 },
  { name: "Your Name Here", event_type: "Family Reunion", quote: "Testimonials from real customers will be featured here as they come in.", rating: 5 },
];

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/content/testimonials")
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const showPlaceholders = loaded && items.length === 0;
  const cards = items.length ? items : PLACEHOLDERS;

  return (
    <div data-testid="testimonials-page" className="bg-bone">
      <section className="pt-28 lg:pt-36 pb-16 bg-charcoal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow text-gold mb-3">Testimonials</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold text-white text-balance max-w-3xl">
            Kind words from our table to yours.
          </h1>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {showPlaceholders && (
            <div className="mb-10 rounded-2xl border border-gold/40 bg-gold/5 p-5 text-center text-sm text-slate-600">
              Client testimonials will be published here. The cards below are placeholders that will be replaced with real reviews.
            </div>
          )}
          <div className="grid gap-6 md:grid-cols-3">
            {cards.map((t, i) => (
              <div key={i} data-testid={`testimonial-card-${i}`}
                className={`rounded-2xl bg-white border border-slate-200 p-7 ${showPlaceholders ? "opacity-70 border-dashed" : ""}`}>
                <Quote className="w-8 h-8 text-gold" />
                <div className="mt-3 flex gap-0.5">
                  {Array.from({ length: t.rating || 5 }).map((_, s) => (
                    <Star key={s} className="w-4 h-4 fill-gold text-gold" />
                  ))}
                </div>
                <p className="mt-4 text-slate-700 leading-relaxed italic">"{t.quote}"</p>
                <div className="mt-6 border-t border-slate-100 pt-4">
                  <div className="font-serif text-lg font-semibold text-charcoal">{t.name}</div>
                  {t.event_type && <div className="text-xs text-crimson uppercase tracking-wider">{t.event_type}</div>}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-14 text-center">
            <p className="text-slate-600">Enjoyed your Taste of Platinum experience?</p>
            <Link to="/contact" data-testid="testimonials-cta"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-charcoal px-7 py-4 font-semibold text-white hover:bg-charcoal-void">
              Share Your Experience <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
